import * as tslib_1 from "tslib";
import * as React from 'react';
var styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '3px',
        padding: '5px',
    },
    text: {
        flex: 1,
        fontSize: '16px',
        fontWeight: 500,
        color: '#fff',
        padding: '.3rem',
        textAlign: 'center',
    },
    title: {
        fontSize: '11px',
        color: '#fff'
    }
};
var TaskSummaryCard = /** @class */ (function (_super) {
    tslib_1.__extends(TaskSummaryCard, _super);
    function TaskSummaryCard(props) {
        return _super.call(this, props) || this;
    }
    TaskSummaryCard.prototype.render = function () {
        var _a = this.props, title = _a.title, text = _a.text, color = _a.color;
        var containerStyle = tslib_1.__assign({}, styles.container, { backgroundColor: color });
        return (React.createElement("div", { style: containerStyle },
            React.createElement("div", { style: styles.title }, title),
            React.createElement("div", { style: styles.text }, text)));
    };
    return TaskSummaryCard;
}(React.Component));
export default TaskSummaryCard;



//////////////////
// WEBPACK FOOTER
// ./src/pages/tasks/TaskSummaryCard.tsx
// module id = 778
// module chunks = 0